// extracted by mini-css-extract-plugin
module.exports = {"optionBoxDes":"OptionBoxDes-module-optionBoxDes--J8EGv","options":"OptionBoxDes-module-options--Yb76H","btnFixed":"OptionBoxDes-module-btnFixed--HTben"};